import { jsPDF } from 'jspdf';
import { mindTheGraphImage } from './mindTheGraphImage.js';

export default function generatePdf(invoice, profile, email) {
  const plan = invoice.formattedPlan === 'undefined undefined' ? 'Upsell' : invoice.formattedPlan;
  const date = invoice.formattedDate;
  let price = invoice.total;
  const name = profile.name;
  const institution = profile.institution;
  const unitPrice = parseInt(price);
  const currency = invoice.currency;
  price = addZeroes(price);

  let today = new Date();
  let dd = today.getDate();
  let mm = today.getMonth() + 1;
  const yyyy = today.getFullYear();
  const hours = today.getHours();
  const minutes = today.getMinutes();
  const seconds = today.getSeconds();
  if (dd < 10) {
    dd = `0 ${dd}`;
  }
  if (mm < 10) {
    mm = `0 ${mm}`;
  }
  today = `${mm}/${dd}/${yyyy} ${hours}:${minutes}:${seconds}`;

  const doc = new jsPDF();

  // Logo image
  doc.addImage(mindTheGraphImage, 'PNG', 10, 10, 34, 11);

  // Line
  doc.setLineWidth(0.2);
  doc.line(10, 25, 200, 25);

  // MtG informations
  doc.setFontSize(12);
  doc.setFont('times', 'bold');
  doc.text(10, 40, 'Cactus Communications Services Pte. Ltd.');
  doc.setFont('times', 'normal');
  doc.text(10, 45, '20 McCallum Street, #19-01,');
  doc.text(10, 50, 'Tokio Marine Centre Singapore - 069046');
  doc.text(10, 55, 'Phone: +1 (833) 979-0061');
  doc.text(10, 60, 'GST Reg. No.: 201526201R');
  doc.text(10, 65, 'E-mail: contact@mindthegraph.com');
  doc.line(10, 70, 100, 70);
  doc.text(90, 75, 'Seller');

  // User informations
  doc.setFont('times', 'bold');
  doc.text(120, 80, name);
  doc.setFont('times', 'normal');
  doc.text(120, 85, `Email: ${email}`);
  if (institution) doc.text(120, 90, institution);
  doc.line(120, 95, 200, 95);
  doc.text(185, 100, 'Buyer');

  // Invoice number (b)
  doc.setFont('times', 'bold');
  doc.text(10, 105, `Invoice number: ${invoice.id}`);
  // Invoice date (b)
  doc.setFont('times', 'bold');
  doc.text(10, 110, `Invoice date: ${today}`);

  // Issue date (payment_date)
  doc.setFont('times', 'normal');
  doc.text(10, 125, `Issue date: ${date}`);
  // Sell date (payment_date)
  doc.text(10, 130, `Sell date: ${date}`);

  // Annual Subscription
  doc.setFont('times', 'bold');
  doc.text(10, 150, plan);

  // Item      VAT  Qty  Unit net price  Discount  Total net  VAT amoun  Total Gross
  doc.text(10, 160, 'Item');
  doc.text(55, 160, 'VAT');
  doc.text(67, 160, 'Qty');
  doc.text(77, 160, 'Unit net price');
  doc.text(107, 160, 'Discount');
  doc.text(128, 160, 'Total net');
  doc.text(149, 160, 'VAT amount');
  doc.text(177, 160, 'Total Gross');
  doc.setFont('times', 'normal');

  // Line
  doc.line(10, 165, 200, 165);

  // Item      VAT  Qty  Unit net price  Discount  Total net  VAT amoun  Total Gross
  doc.text(10, 170, 'Mind the Graph');
  doc.text(10, 175, plan);
  doc.text(58, 170, '0');
  doc.text(69, 170, '1');
  doc.text(85, 170, unitPrice.toString());
  doc.text(113, 170, '0%');
  doc.text(133, 170, unitPrice.toString());
  doc.text(158, 170, '0');
  doc.text(185, 170, price);

  // Line
  doc.line(10, 177, 200, 177);

  // Total
  doc.setFont('times', 'bold');
  doc.text(82, 182, 'Total');
  doc.setFont('times', 'normal');
  doc.text(108, 182, price);

  // Total Payments: USD price (b)
  doc.setFont('times', 'bold');
  doc.setFontSize(20);
  doc.text(90, 210, `Total Payments: ${currency} ${price}`);

  doc.save(`mtg-invoice-${today}.pdf`);
}

function addZeroes(num) {
  let value = Number(num);
  const res = num.toString().split('.');
  if (num.toString().indexOf('.') === -1) {
    value = value.toFixed(2);
    num = value.toString();
  } else if (res[1].length < 3) {
    value = value.toFixed(2);
    num = value.toString();
  }
  return num;
}
